export default __webpack_public_path__ + "static/media/empty-data-6.07f27587.svg";